module.exports = __webpack_public_path__ + "static/media/pixel_background.8dbc1d9a.png";